<template>
  <div class="main">
    <div>
      <input class="field" placeholder="手机" type="tel" v-model.trim="mobilePhone" />
      <input class="field" placeholder="密码" type="password" v-model.trim="password" />
      <div class="field_box">
        <div class="btn_small" @click="getSmsCode" v-if="smsCodeTime === 0">获取验证码</div>
        <div class="btn_small" v-if="smsCodeTime > 0">{{smsCodeTime}}s</div>
        <input class="field" placeholder="验证码" type="text" v-model.trim="smsCode" />
      </div>
    </div>
    <div class="btn_large" @click="resetPassword">重置密码</div>
    <div class="btn_box">
      <div class="btn_center">已有账户？<span @click="goToLogin">立即登录</span></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'ResetPassword',
  data: function () {
    return {
      mobilePhone: '',
      fullName: '',
      password: '',
      smsCode: '',
      smsCodeTime: 0
    }
  },
  methods: {
    async getSmsCode () {
      try {
        if (!this.mobilePhone) {
          return Toast({
            message: '请填写手机号码'
          })
        }
        this.smsCodeTime = 60
        const smsCodeTimer = setInterval(() => {
          this.smsCodeTime -= 1
          if (this.smsCodeTime <= 0) {
            clearInterval(smsCodeTimer)
          }
        }, 1000)
        await this.$faApi.getResetPasswordSmsCode({
          mobilePhone: this.mobilePhone
        })
      } catch (err) {
        this.$faLogger.error('ResetPassword.vue:getSmsCode', err)
      }
    },

    async resetPassword () {
      try {
        if (!this.mobilePhone) {
          return Toast({
            message: '请填写手机号码'
          })
        }

        if (!this.password) {
          return Toast({
            message: '请填写密码'
          })
        }

        if (!this.smsCode) {
          return Toast({
            message: '请填写验证码'
          })
        }

        const res = await this.$faApi.resetPassword(
          this.mobilePhone,
          this.password,
          this.smsCode
        )
        
        if (res.code === 'INVALID_SMS_CODE') {
          return Toast({
            message: '验证码错误'
          })
        }
        
        this.$router.push({ path: '/login' })
      } catch (err) {
        this.$faLogger.error('ResetPassword.vue:resetPassword', err)
      }
    },
    
    goToLogin() {
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    margin: 0 auto;
    padding: 16px;
    max-width: 320px;
  }
  .brand_box {
    margin-bottom: 48px;
    position: relative;
    text-align: center;
    .title {
      margin: 0;
      font-size: 30px;
      font-weight: bold;
      span {
        font-weight: bold;
      }
    }
    .subtitle {
      margin: 0;
      font-size: 18px;
      font-weight: 300;
      color: black;
    }
    .logo {
      position: relative;
      margin: 16px auto;
      width: 160px;
      height: 160px;
    }
    .logo_image {
      position: relative;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('../assets/logo_960.png');
    }
  }
  .field_box {
    position: relative;
  }
  .field {
    margin: 8px 0 0 0;
    width: 100%;
    height: 40px;
    border-width: 0 0 1px 0;
    border-radius: 0;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff8;
    text-align: left;
    font-size: 16px;
    font-weight: 300;
  }
  .btn_small {
    position: absolute;
    top: 12px;
    right: 0;
    margin: 0;
    padding: 0 4px;
    width: 80px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px;
    text-align: center;
    color: white;
    background-color: red;
    z-index: 999;
    cursor: pointer;
  }
  .btn_large {
    margin: 24px auto 16px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 900;
    text-align: center;
    color: white;
    background-color: red;
    cursor: pointer;
  }
  .btn_box {
    position: relative;
    width: auto;
    height: 32px;
  }
  .btn_center {
    position: relative;
    width: auto;
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    color: darkgray;
    span {
      font-weight: bold;
      color: red;
      cursor: pointer;
    }
  }
</style>
  